import ObjectMapper from 'object-mapper'
import merge from 'lodash.merge'

// tasks#202: applied only when present in the diff (an absent key must not clear the window), an explicit
// {new: null} clears it ('?' destination)
const PRESENT_ONLY_KEYS = ['estimated_window_from', 'estimated_window_to']

export default {
    data() {
        return {
            orderMap: {
                created_at: 'created_at',
                status: 'order_status',
                delivery_job_id: 'delivery_job.id',
                courier_lat: 'delivery_job.courier_lat',
                courier_long: 'delivery_job.courier_long',
                eta_to_dropoff: 'delivery_job.eta_to_dropoff',
                courier_status: 'delivery_job.courier_status',
                is_delivery_processed: 'is_delivery_processed',
                required_delivery_time: 'required_delivery_time',
                updated_at: 'updated_at',
                cancel_source: 'cancel_source',
                warning: 'warning?',
                warnings: 'warnings?',
                sent_ratio: 'sentRatio',
                label_codes: 'label_codes',
                estimated_window_from: 'delivery_job.estimatedWindowFrom?',
                estimated_window_to: 'delivery_job.estimatedWindowTo?',
            },
            trackerMap: {
                id: 'id',
                created_at: 'createdAt',
                status: 'status',
                delivery_job_id: 'id',
                courier_lat: 'courierLat',
                courier_long: 'courierLong',
                eta_to_dropoff: 'etaToDropoff',
                courier_status: 'courierStatus',
                is_delivery_processed: 'isDeliveryProcessed',
                estimated_window_from: 'estimatedWindowFrom?',
                estimated_window_to: 'estimatedWindowTo?',
            },
            thirdPartyOrderMap: {
                third_party_order_id: 'thirdPartyOrderId',
                restaurant_third_party_type: 'restaurantThirdPartyType',
                third_party_tracking_url: 'thirdPartyTrackingUrl',
                third_party_code: 'thirdPartyCode',
            },
        }
    },
    methods: {
        getResult(object, data, map) {
            data = { ...data }
            Object.entries({ ...data }).forEach(([key, value]) => {
                data[key] = value?.new
            })
            const presentMap = { ...map }
            PRESENT_ONLY_KEYS.forEach((key) => {
                if (!(key in data)) delete presentMap[key]
            })
            return merge(object || {}, ObjectMapper(data, presentMap))
        },
    },
}
